var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('a-config-provider',{attrs:{"locale":_vm.locale}},[_c('div',{attrs:{"id":"app"}},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),_c('div',{staticStyle:{"width":"0","height":"0"},attrs:{"id":"map"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }